import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { LoadingComponent } from '../../components/loading/loading.component';
import { ClaveUnicaService } from '../../services/claveunica.service';

@Component({
  selector: 'app-claveunica-callback',
  standalone: true,
  imports: [LoadingComponent],
  templateUrl: './claveunica-callback.component.html',
  styleUrl: './claveunica-callback.component.css',
})
export class ClaveUnicaCallbackComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly claveUnicaService = inject(ClaveUnicaService);
  private readonly titleService = inject(Title);
  // URL de logout de ClaveÚnica
  private readonly CLAVE_UNICA_LOGOUT_URL =
    'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout';

  async ngOnInit() {
    // Cambiar el título de la página
    this.titleService.setTitle('ClaveÚnica');

    try {
      // Obtener los query params de forma síncrona
      const params = await firstValueFrom(this.route.queryParams);

      const code = params['code'];
      const state = params['state'];

      // Validar que existan los parámetros
      if (!code || !state) {
        throw new Error('Parámetros de callback inválidos');
      }

      await this.claveUnicaService.callback(code, state);
    } catch (error: unknown) {
      console.error('Error en callback de ClaveÚnica:', error);
      let tipoError = 'general';

      if (typeof error === 'object' && error !== null && 'status' in error) {
        const status = (error as { status: number }).status;
        if (status === 401) {
          tipoError = 'auth'; // Sesión expirada
        } else if (
          status === 400 &&
          (error as any)?.error?.mensaje.includes('no coincide con el RUT')
        ) {
          tipoError = 'rutdiff'; // RUT no coincide
        } else {
          tipoError = 'general'; // Acceso denegado
        }
      } else {
        tipoError = 'general';
      }

      window.location.href = this.CLAVE_UNICA_LOGOUT_URL;
      // Esperar un momento breve para dar tiempo al logout
      await new Promise((resolve) => setTimeout(resolve, 300));

      const rutaAnterior = (error as any)?.error?.datos?.redirectUrl ?? sessionStorage.getItem(this.claveUnicaService.SESSION_STORAGE_KEYS.ERROR_URL);

      // Redirigir a la página de error específica de ClaveÚnica
      this.router.navigate(['/claveunica/error'], {
        state: {
          tipoError,
          rutaAnterior
        },
      });
    }
  }
}
